import React, { useEffect, useState } from "react";
import "../../global.scss";
import "./addVehicle.scss";
import "../OnBoarding/manageYourVehicle.scss";

import {
  IonRow,
  IonCol,
  IonButton,
  IonLabel,
  IonIcon,
  IonInput,
  isPlatform,
  IonToast,
} from "@ionic/react";
import {
  MANAGE_YOUR_VEHICLE,
  DEFAULT,
  HONDA_CITY,
  YEAR_DIESEL,
  NICK_NAME,
  REG_NO,
  ODOMETER,
  DEFAULT_LOCATION,
  VIN_NUMBER,
  HOME,
  CHANGE,
  SAVE_AND_UPLOAD_DOCUMENT,
  PLEASE_ENTER_NICK_NAME,
  PLEASE_ENTER_VIN_NUMBER,
  PLEASE_ENTER_VALID_ODOMETER,
  PLEASE_ENTER_VALID_VIN_NUMBER,
  PLEASE_ENTER_ODOMETER,
  PLEASE_ENTER_REGISTERED_NUMBER,
  PLEASE_ENTER_VALID_REGISTERED_NUMBER,
  PLEASE_ENTER_VALID_NICK_NAME,
  REGISTRATION_NUMBER,
} from "../../constants";

import {
  alphaAndNumbers,
  alphabitsLetters,
  isSplChar,
  checkForOnlyNumber,
  checkMediaQuery,
} from "../../utils";
import { connect } from "react-redux";
import {
  COLLECTIONS,
  fireStoreDbInstance,
  saveDocumentData,
  uploadImageToFireStorage,
} from "../../firebase";
import { updateVehicleDefaultAddress } from "../../Store/Actions";
import { CustomIonImage } from "../CustomComponents/IonImg";
import { Camera, CameraOptions } from "@ionic-native/camera";
import firebase from "firebase";
import { ToastMessage } from "../../utils/toastMessage";

const ManageYourVehicle: React.FC = (props: any) => {
  const [state, setState] = useState<any>({
    vehicle: {},
    address: {},
    vehicleDocuments: [],
  });
  const [toast, setToast] = useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });
  const [keyboardOpened, setKeyboardOpened] = useState(false);
  const [disableButton, setButtonDisabled] = useState(false);
  React.useEffect(() => {
    const vehicle = (props.userVehiclesList || []).find(
      (ele: any) => ele.did === props.match.params.id,
    );
    !!vehicle &&
      vehicle.documentIds.length &&
      vehicle.documentIds.reduce((acc: Array<any>, vehicle: any) => {
        acc.push(
          (props.userDocuments || []).find((ele: any) => ele.did === vehicle.split("/").pop()),
        );
        return acc;
      }, []);
    const address =
      !!vehicle &&
      props.userAddressList.find(
        (ele: any) => ele.did === (vehicle.defaultAddressRef || "").split("/").pop(),
      );
    setState({
      vehicle: {
        ...vehicle,
        imagePaths:
          !!vehicle && vehicle.hasOwnProperty("imagePaths") ? vehicle.imagePaths : ["", "", ""],
      },
      address,
    });
    return () => {
      setState({
        vehicle: {},
        address: {},
        vehicleDocuments: [],
      });
    };
  }, [props.userAddressList, props.userVehiclesList, props.userDocuments]);

  const updateVehicleDetails = async () => {
    try {
      const {
        did,
        nickName = "",
        odometer = "",
        registrationNumber = "",
        vinNumber = "",
        defaultAddressRef = "",
        ...rest
      } = state.vehicle;
      if (!nickName.length || !alphabitsLetters(nickName)) {
        throw Error(!nickName.length ? PLEASE_ENTER_NICK_NAME : PLEASE_ENTER_VALID_NICK_NAME);
      }
      if (!registrationNumber.length || !alphaAndNumbers(registrationNumber)) {
        throw Error(
          !registrationNumber.length
            ? PLEASE_ENTER_REGISTERED_NUMBER
            : PLEASE_ENTER_VALID_REGISTERED_NUMBER,
        );
      }
      if (!vinNumber.length || !alphaAndNumbers(vinNumber)) {
        throw Error(!vinNumber.length ? PLEASE_ENTER_VIN_NUMBER : PLEASE_ENTER_VALID_VIN_NUMBER);
      }
      if (!odometer.length || isNaN(odometer) || odometer < 0) {
        throw Error(!odometer.length ? PLEASE_ENTER_ODOMETER : PLEASE_ENTER_VALID_ODOMETER);
      }
      setButtonDisabled(true);
      const db = await fireStoreDbInstance();
      const b: any = await saveDocumentData(
        props.uid,
        {
          ...rest,
          nickName,
          odometer,
          vinNumber,
          registrationNumber,
          defaultAddressRef: !!state.vehicle.defaultAddressRef
            ? state.vehicle.defaultAddressRef
            : "",
          // documentIds: Object.keys(rest).includes("documentIds")
          //   ? rest.documentIds.map((ele: any) => db.doc(ele))
          //   : [],
          documentIds: Object.keys(rest).includes("documentIds")
            ? rest.documentIds.map((ele: any) => ele)
            : [],
        },
        COLLECTIONS.USERS,
        COLLECTIONS.VECHICLES,
        did,
      );
      if (b.success) {
        setToast({
          toastMessage: "Saved Successfully",
          showToast: true,
          severity: "success",
        });
      }
      await props.updateVehicleDefaultAddress(state.vehicle);
      setTimeout(() => {
        props.history.push(`/portal/upload-documents/${state.vehicle.did}`);
      }, 1000);
    } catch (e: any) {
      setToast({
        toastMessage: e.message,
        showToast: true,
        severity: "warning",
      });
    }
  };

  const handleFileUpload = async (event: any, index: any) => {
    try {
      // console.log("180 =====");
      const file = event.target.files[0];
      if (["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        const updatedFileName = `${file.name} ${Date.now()}`;
        const response: any = await uploadImageToFireStorage(
          props.uid,
          file,
          updatedFileName,
          "vehicles",
        );
        state.vehicle.imagePaths[index] = response.snapshot.metadata.fullPath;
        setState({
          ...state,
          vehicle: {
            ...state.vehicle,
            imagePaths: state.vehicle.imagePaths,
          },
        });
      } else {
        throw Error("Please upload valid format");
      }
    } catch (e: any) {
      setToast({
        showToast: true,
        toastMessage: e.message,
        severity: "warning",
      });
    }
  };

  const options: CameraOptions = {
    destinationType: Camera.DestinationType.DATA_URL,
    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
  };

  const AccessNativeCamera = async (index: any) => {
    // console.log("216 AccessNativeCamera =====");
    Camera.getPicture(options).then(
      async (imageData) => {
        let base64Image = "data:image/jpeg;base64," + imageData;
        const res: any = await firebase
          .storage()
          .ref()
          .child(`${props.uid}/${"vehicles"}/${Date.now()}`)
          .putString(base64Image, "data_url", { contentType: "image/jpeg" })
          .then((snapshot) => {
            return snapshot.metadata.fullPath;
          });
        state.vehicle.imagePaths[index] = res;
        setState({
          ...state,
          imagePaths: state.vehicle.imagePaths,
        });
      },
      (err: any) => {
        console.error(err, "CamError");
      },
    );
  };

  const handleChange = (imgPath: any) => {
    setState({
      ...state,
      vehicle: {
        ...state.vehicle,
        imagePaths: (state.vehicle.imagePaths || []).map((ele: any, index: any) => {
          if (ele === imgPath) {
            return "";
          }
          return ele;
        }),
      },
    });
  };

  useEffect(() => {
    window.addEventListener("keyboardWillShow", () => {
      if (isPlatform("ios")) {
        setKeyboardOpened(true);
      }
    });
    window.addEventListener("keyboardDidHide", () => {
      setKeyboardOpened(false);
    });
    return () => {
      window.removeEventListener("keyboardWillShow", () => {
        setKeyboardOpened(false);
      });
      window.removeEventListener("keyboardDidHide", () => {
        setKeyboardOpened(false);
      });
    };
  }, []);

  return (
    <>
      <IonCol className="middle_panle res_bg_color" size-md="6">
        <>
          {isPlatform("ios") && <div className="ios_statusbar_color" />}
          <div className="personal_details_div wholeApp">
            <div
              className="personal_details_div_child manage_veh_header_float"
              style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
            >
              <img
                src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
                className="back_arrow"
                onClick={() => props.history.goBack()}
              />
              <IonLabel className="personal_details_labels" color="secondary">
                {MANAGE_YOUR_VEHICLE}
              </IonLabel>
              <div />
            </div>
          </div>
          <div className="personal_details_text manage_vehicle_layout MV_marginT_80 left_right_padding">
            <IonRow className="manage_vehicle_div">
              <IonCol offset-md="2" size-md="8" size="12">
                <div className="manage_vehicle_body">
                  <div className="manage_vehicle">
                    <img
                      src={
                        !!state.vehicle && state.vehicle.hasOwnProperty("imageUrl")
                          ? state.vehicle.imageUrl
                          : ""
                      }
                      className="manage_vehicle_img"
                    />
                  </div>
                  <div className="brand_data">
                    <IonLabel className="brand_text" color="light">
                      {!!state.vehicle && state.vehicle.make}{" "}
                      {!!state.vehicle && state.vehicle.model}
                    </IonLabel>
                    <IonLabel className="brand_year" color="light">
                      {!!state.vehicle &&
                        state.vehicle.hasOwnProperty("year") &&
                        state.vehicle.year}
                      {!!state.vehicle && state.vehicle.hasOwnProperty("year") && ","}{" "}
                      {!!state.vehicle && state.vehicle.fuelType}
                    </IonLabel>
                  </div>
                  {state.vehicle.did === (props.defaultVehicleRef || "").split("/").pop() && (
                    <div className="default">
                      <IonLabel className="default_text" color="light">
                        {DEFAULT}
                      </IonLabel>
                    </div>
                  )}
                </div>
              </IonCol>
            </IonRow>
            <IonRow className="vehicle_details">
              <IonCol className="text_center_label" offset-md="2" size-md="3" size="6">
                <IonLabel className="input_label" color="tertiary">
                  {NICK_NAME}
                </IonLabel>
              </IonCol>
              <IonCol size-md="5" size="6">
                <input
                  className="input_text manage_vh_input_text capitalize changePlaceholderColor"
                  placeholder={"My Car"}
                  type="text"
                  color="secondary"
                  value={!!state.vehicle && !!state.vehicle.nickName ? state.vehicle.nickName : ""}
                  onChange={(event) => {
                    if (alphabitsLetters(event.target.value) || event.target.value === "") {
                      setState({
                        ...state,
                        vehicle: {
                          ...state.vehicle,
                          nickName: event.target.value,
                        },
                      });
                    }
                  }}
                />
              </IonCol>
              <IonCol className="text_center_label" offset-md="2" size-md="3" size="6">
                <IonLabel className="input_label" color="tertiary">
                  {REG_NO}{" "}
                </IonLabel>
              </IonCol>
              <IonCol className="text_center_label" size-md="5" size="6">
                <input
                  className="manage_vh_input_text uppercase changePlaceholderColor"
                  placeholder={REGISTRATION_NUMBER}
                  type="text"
                  color="secondary"
                  value={
                    !!state.vehicle && !!state.vehicle.registrationNumber
                      ? state.vehicle.registrationNumber
                      : ""
                  }
                  onChange={(event) => {
                    if (!isSplChar(event.target.value)) {
                      setState({
                        ...state,
                        vehicle: {
                          ...state.vehicle,
                          registrationNumber: event.target.value,
                        },
                      });
                    }
                  }}
                />
              </IonCol>
              <IonCol className="text_center_label" offset-md="2" size-md="3" size="6">
                <IonLabel className="input_label" color="tertiary">
                  {VIN_NUMBER}{" "}
                </IonLabel>
              </IonCol>
              <IonCol className="text_center_label" size-md="5" size="6">
                <input
                  className="manage_vh_input_text uppercase changePlaceholderColor"
                  placeholder="123456789"
                  type="text"
                  color="secondary"
                  value={
                    !!state.vehicle && !!state.vehicle.vinNumber ? state.vehicle.vinNumber : ""
                  }
                  onChange={(event) => {
                    setState({
                      ...state,
                      vehicle: {
                        ...state.vehicle,
                        vinNumber: event.target.value.trim().length ? event.target.value : "",
                      },
                    });
                  }}
                />
              </IonCol>
              <IonCol className="text_center_label" offset-md="2" size-md="3" size="6">
                <IonLabel className="input_label" color="tertiary">
                  {ODOMETER}{" "}
                </IonLabel>
              </IonCol>
              <IonCol size-md="5" size="6">
                <input
                  type="tel"
                  className="odometer_text changePlaceholderColor"
                  color="secondary"
                  max={10}
                  onChange={(event) =>
                    (/^\d+$/.test(event.target.value) || !event.target.value) &&
                    event.target.value.length < 7
                      ? setState({
                          ...state,
                          vehicle: {
                            ...state.vehicle,
                            odometer: event.target.value,
                          },
                        })
                      : null
                  }
                  value={!!state.vehicle && !!state.vehicle.odometer ? state.vehicle.odometer : ""}
                  placeholder="10,000 KM"
                />
              </IonCol>

              {/* <IonCol //for web
                className="upload_images_mobile"
                offset-md="2"
                size-md="6"
                size="12"
              >
                <IonLabel className="image_upload" color="secondary">
                  Images
                </IonLabel>
                <div>
                  <div className="upload-car-images">
                    {!!state.vehicle &&
                      !!state.vehicle.imagePaths &&
                      state.vehicle.imagePaths.map((ele: any, index: any) =>
                        !!ele ? (
                          <div className="upload-rc-documents" key={index}>
                            <CustomIonImage imgpath={ele} />
                            <img
                              src={"/images/close-icon.svg"}
                              className="document-remove-icon"
                              onClick={() => handleChange(ele)}
                            />
                          </div>
                        ) : (
                          <div
                            className="upload-rc-documents"
                            onClick={() => AccessNativeCamera(index)}
                            key={index}
                          >
                            <img src={"/images/add.svg"} />
                            {(isPlatform("desktop") ||
                              isPlatform("mobileweb")) && (
                              <input
                                type="file"
                                className="input_type_file"
                                accept=".png , .jpg, .pdf"
                                onChange={(event: any) => {
                                  handleFileUpload(event, index);
                                  event.target.value = null;
                                }}
                              />
                            )}
                          </div>
                        )
                      )}
                  </div>
                </div>
              </IonCol> */}
              {/* <IonCol
              className="default_adress"
              offset-md="2"
              size-md="7"
              size="12"
            >
              <div>
                <div className="default-address-details">
                  <IonLabel color="tertiary" className="default_location">
                    {DEFAULT_LOCATION}{" "}
                    <span color="primary" className="home">
                      {!!state.address && state.address.addressType}
                    </span>
                  </IonLabel>
                  <IonLabel
                    color="darkpink"
                    className="change"
                    onClick={() => {
                      props.updateVehicleDefaultAddress({
                        ...state.vehicle,
                      });
                      props.history.push({
                        pathname: "/portal/my-addresses",
                        state: {
                          vehicleId: props.match.params.id,
                        },
                      });
                    }}
                  >
                    {!!state.address ? CHANGE : "Add"}
                  </IonLabel>
                </div>
                {!!state.address && (
                  <IonLabel className="location_address" color="secondary">
                    {!!state.address &&
                      `${state.address.addressline1} ${","}
                    ${state.address.landmark} ${","}
                    ${state.address.city} ${","}
                    ${state.address.postalCode}
                    ${","}
                    ${state.address.country}`}
                  </IonLabel>
                )}
              </div>
            </IonCol> */}
            </IonRow>
            {/* <IonRow>
              <IonCol
                offset-md="2"
                size-md="8"
                size="12"
                className="upload_btn_div"
              >
                <IonButton
                  color="lightgreen"
                  className="continue_btn child_btn upload_btn"
                  onClick={() => {
                    updateVehicleDetails();
                  }}
                  disabled={disableButton}
                >
                  {SAVE_AND_UPLOAD_DOCUMENT}
                </IonButton>
              </IonCol>
            </IonRow> */}
            <IonCol //for mobile
              className="upload_images_mobile upload-images-manage-vehicle"
              offset-md="2"
              size-md="6"
              size="12"
            >
              <IonLabel className="image_upload" color="secondary">
                Images
              </IonLabel>
              <div>
                <div
                  className="upload-car-images upload-images-manage-vehicle"
                  style={{ justifyContent: "flex-start" }}
                >
                  {!!state.vehicle &&
                    !!state.vehicle.imagePaths &&
                    state.vehicle.imagePaths.map((ele: any, index: any) =>
                      !!ele ? (
                        <div
                          className="upload-rc-documents"
                          style={{ marginRight: 10 }}
                          key={index}
                        >
                          <CustomIonImage imgpath={ele} />
                          <img
                            src={"/images/close-icon.svg"}
                            className="document-remove-icon"
                            onClick={() => handleChange(ele)}
                          />
                        </div>
                      ) : (
                        <div
                          className="upload-rc-documents"
                          style={{ marginRight: 10 }}
                          onClick={() => AccessNativeCamera(index)}
                          key={index}
                        >
                          <img src={"/images/add.svg"} />
                          {(isPlatform("desktop") || isPlatform("mobileweb")) && (
                            <input
                              type="file"
                              className="add-car-image"
                              accept=".png, .jpg, .jpeg"
                              onChange={(event: any) => {
                                handleFileUpload(event, index);
                                event.target.value = null;
                              }}
                            />
                          )}
                        </div>
                      ),
                    )}
                </div>
              </div>
            </IonCol>
            <ToastMessage
              showToast={toast.showToast}
              ToastMessage={toast.toastMessage}
              severity={toast.severity}
              onDidDismiss={() => {
                setToast({
                  showToast: false,
                  toastMessage: "",
                  severity: "",
                });
              }}
            />
            {!!keyboardOpened && (
              <IonRow>
                <IonCol
                  offset-md="2"
                  size-md="8"
                  size="12"
                  className="upload_btn_div manage_veh_save"
                  style={{ position: "unset", padding: 0, marginTop: 30 }}
                >
                  <IonButton
                    color="lightgreen"
                    className="continue_btn child_btn upload_btn"
                    style={{
                      marginBottom: 30,
                    }}
                    onClick={() => {
                      updateVehicleDetails();
                    }}
                    disabled={disableButton}
                  >
                    {SAVE_AND_UPLOAD_DOCUMENT}
                  </IonButton>
                </IonCol>
              </IonRow>
            )}
          </div>
          {!keyboardOpened && (
            <IonRow>
              <IonCol
                offset-md="2"
                size-md="8"
                size="12"
                className="upload_btn_div manage_veh_save"
              >
                <IonButton
                  color="lightgreen"
                  className="continue_btn child_btn upload_btn"
                  style={{
                    marginBottom: 30,
                  }}
                  onClick={() => {
                    updateVehicleDetails();
                  }}
                  disabled={disableButton}
                >
                  {SAVE_AND_UPLOAD_DOCUMENT}
                </IonButton>
              </IonCol>
            </IonRow>
          )}
        </>
      </IonCol>
    </>
  );
};

export default connect(
  ({ auth, userInfo: { userVehiclesList, userAddressList, userDocumentsList } }: any) => ({
    ...auth,
    userVehiclesList,
    userAddressList,
    userDocumentsList,
  }),
  { updateVehicleDefaultAddress },
)(ManageYourVehicle);
